
export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-block px-4 py-2 bg-emerald-900 text-white text-xs font-semibold rounded-full mb-6">
            ATLANTA'S TRUSTED STUMP GRINDING EXPERTS
          </div>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Upgrade Your Property Today
          </h2>
        </div>

        <div className="space-y-6 mb-10">
          <p className="text-base text-gray-700 leading-relaxed font-medium text-center max-w-3xl mx-auto">
            Professional stump grinding transforms your property by eliminating unsightly tree stumps and creating a safer, more beautiful outdoor space. Our expert stump removal services in Buckhead, Vinings, Marietta, and Smyrna help property owners reclaim valuable yard space while preventing future landscape problems.
          </p>
          
          <div className="space-y-4 max-w-3xl mx-auto">
            <h3 className="text-lg font-bold text-gray-900 text-center">Key Benefits of Professional Stump Grinding:</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-base text-gray-700"><strong>Enhanced Safety:</strong> Eliminate tripping hazards and protect children, pets, and lawn equipment from dangerous stump obstacles</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-base text-gray-700"><strong>Pest Prevention:</strong> Remove breeding grounds for termites, carpenter ants, beetles, and other wood-boring insects that threaten your home</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-base text-gray-700"><strong>Improved Curb Appeal:</strong> Boost property value and create a clean, polished landscape that enhances your home's aesthetic</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-base text-gray-700"><strong>Prevent New Growth:</strong> Stop unwanted sprouts and shoots from draining nutrients from surrounding plants and grass</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-base text-gray-700"><strong>Maximize Usable Space:</strong> Reclaim valuable yard area for landscaping, gardens, patios, or play areas</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-base text-gray-700"><strong>Disease Control:</strong> Remove diseased stumps that can spread fungal infections to healthy trees and plants</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
